import React from 'react'
import Header from '../component/Header'
import Donate from '../component/Donate'
import BottomBar from '../component/BottomBar'
import { FaAngleRight } from 'react-icons/fa6'
import { Helmet } from 'react-helmet-async'

function OurImpact() {

    
  const year = new Date().getFullYear();
  const donationClick =()=>{
      const menu_dropdown = document.querySelector(".donate_header")
      menu_dropdown.classList.toggle("donate_dropDown");
  }

  return (
    <>
        <Helmet>
            <title>Our Impact | The Lord Nations Foundation</title>
            <meta name="description" content="Discover the impact of The Lord Nations Foundation. See how our programs and initiatives are transforming lives and communities around the world." />
        </Helmet>


        <div className='home' >
            <Header/>
            <div className='about_head_spacer'></div>
            <div className='ourimpactbanner' >
                <div className='homebanner_overlay'>
                    <div className='homebanner_container'>
                        <div className='homebanner_text' >
                            <div className='donatenow_banner_label' >
                                <h3>OUR IMPACT</h3>
                            </div>
                        </div>

                        <div className='danate_desk'>
                            <Donate/>
                        </div>
                    </div>
                </div>
            </div>

            <div className='danate_mob'>
            <Donate/>
            </div>

            
            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h1>ENSURING NO CHILD IS LEFT BEHIND</h1>
                </div>

                <p>
                    We go to remote corners, villages, and cities where it's really tough to be a child. We ask children, their families, and communities what children need to be healthy, safe, and learning. We listen to their experiences, insight, and ideas.  
                </p>

                <p>
                    Together, we work hand in hand to adapt and create new solutions for children facing crisis, now and in the future.          
                </p>

                <p>
                    Today, we’re proudly working with children, their communities, and our partners worldwide, discovering new solutions and creating lasting change, together.     
                </p>
            </div>

            <div className='about_sub' >
                <div className='about_sub_body'>
                    <div className='ourimpact_sub_body_img2'></div>

                    <div className='about_sub_body_writeup'>

                        <div className='about_sub_body_writeup_body donate_now_write_ups'>
                            <h1 style={{margin:'10px 0', width:'90%', textAlign:'center'}}>Transforming the lives of children in {year}</h1>
                            <p>
                                Despite all the challenges that children have faced this year, with your support, we were able to make incredible strides for them and their universally recognised rights.
                            </p>
                            <div onClick={()=>donationClick()} className='donate_now_write_ups_btn'>
                                <p>DONATE NOW</p>
                                <FaAngleRight/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='about_sub' >
                <div className='about_sub_body'>
                    <div className='about_sub_body_writeup'>

                        <div className='about_sub_body_writeup_body donate_now_write_ups'>
                            <p>
                                We are committed to creating change for children, achieved in partnership, that realise children’s rights at scale, improve equality, and support children’s power.
                            </p>
                            <div onClick={()=>donationClick()} className='donate_now_write_ups_btn'>
                                <p>DONATE NOW</p>
                                <FaAngleRight/>
                            </div>
                        </div>
                    </div>

                    <div className='ourimpact_sub_body_img3'></div>
                </div>
            </div>
            
            <BottomBar/>
        </div>
    </>
  )
}

export default OurImpact